// A selector returning `possiblyUndefinedObject || {}` or `possiblyUndefinedArray || []` will create a new object on each call,
// which prevents memoization when selectors are composed. Import empty constants instead so selectors won’t retrigger.

export const emptyArray = [] as const;

export const emptyObject = {} as const;
